/**
 * UranIA PA — `/accesso-negato` (403 esplicito).
 *
 * Unica eccezione dichiarata al principio "chi sbaglia area torna al
 * proprio atterraggio, mai a una schermata d'errore" (Riordino della
 * mappa delle rotte §5): quando l'utente ha seguito un link legittimo di
 * un altro ente, un redirect silenzioso mentirebbe. Questa pagina non ha
 * una guardia propria — è la destinazione a cui *altre* guardie
 * (server-side, fuori dalla SPA) possono mandare esplicitamente.
 */

import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from '@tanstack/react-router';
import type { JSX } from 'react';

import { ruoloCorrente } from '../../lib/auth/ruolo-corrente.ts';
import { smistaRadice } from '../../lib/ruoli.ts';

export function AccessoNegatoPage(): JSX.Element {
  const { t } = useTranslation();
  const backTo = useMemo(() => smistaRadice(ruoloCorrente()) ?? '/', []);

  return (
    <section
      className="container py-5"
      data-testid="accesso-negato-page"
      aria-labelledby="accesso-negato-heading"
    >
      <div className="mx-auto text-center" style={{ maxWidth: 560 }}>
        <span
          className="badge mb-3"
          style={{
            backgroundColor: '#f8d7da',
            color: '#842029',
            fontSize: '0.7rem',
            letterSpacing: '0.05em',
          }}
        >
          403
        </span>
        <h1 id="accesso-negato-heading" className="h3 mb-2">
          {t('sistema.accesso_negato.title')}
        </h1>
        <div className="alert alert-warning text-start" role="alert">
          <p className="mb-0">{t('sistema.accesso_negato.body')}</p>
        </div>
        <Link to={backTo} className="btn btn-primary" data-testid="accesso-negato-back">
          {t('sistema.accesso_negato.back_to_landing')}
        </Link>
      </div>
    </section>
  );
}
